class JbImageSlider extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        const swiper = new Swiper(this, {
            slidesPerView: 1,
            spaceBetween: 30,
            pagination: {
                el: '.swiper-pagination',
            },
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
        });
    }
}

if(!customElements.get('jb-image-slider')){
    customElements.define('jb-image-slider', JbImageSlider);
}


class JbFeatCollectionSlider extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        const prevEl = this.closest(".slider_wrapper").querySelector('.swiper-button-prev');
        const nextEl = this.closest(".slider_wrapper").querySelector('.swiper-button-next');
        const swiper = new Swiper(this, {
            slidesPerView: 3,
            spaceBetween: 10,
            navigation: {
                nextEl: nextEl,
                prevEl: prevEl,
            },
            breakpoints: {
                768: {
                    slidesPerView: 6,
                    spaceBetween: 20,
                },
                1024: {
                    slidesPerView: 8,
                },
            },
        });
    }
}

if(!customElements.get('jb-feat-collection-slider')){
    customElements.define('jb-feat-collection-slider', JbFeatCollectionSlider);
}

class JbProductSlider extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        const swiper = new Swiper(this, {
            slidesPerView: 2,
            spaceBetween: 8,
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
            breakpoints: {
                768: {
                    slidesPerView: 3,
                    spaceBetween: 16,
                },
                992: {
                    slidesPerView: 4,
                },
                1024: {
                    slidesPerView: 5,
                },
            },
        });
    }
}

if (!customElements.get('jb-product-slider')) {
    customElements.define('jb-product-slider', JbProductSlider);
}


class JbBrandSlider extends HTMLElement {
    constructor() {
        super();
    }
    connectedCallback() {
        const swiper = new Swiper(this, {
            slidesPerView: 2,
            spaceBetween: 8,
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
            breakpoints: {
                768: {
                    slidesPerView: 3,
                    spaceBetween: 16,
                },
                992: {
                    slidesPerView: 4,
                },
            },
        });
    }
}

if (!customElements.get('jb-brand-slider')) {
    customElements.define('jb-brand-slider', JbBrandSlider);
}


class JbReviewSlider extends HTMLElement {
    constructor() {
        super();
    }
    connectedCallback() {
        const swiper = new Swiper(this, {
            slidesPerView: 1,
            spaceBetween: 16,
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
            breakpoints: {
                768: {
                    slidesPerView: 2,
                },
                992: {
                    slidesPerView: 3,
                },
            },
        });
    }
}

if (!customElements.get('jb-review-slider')) {
    customElements.define('jb-review-slider', JbReviewSlider);
}


class JBCardButtons extends HTMLElement {
    constructor() {
        super();
        this.addToCart = this.querySelector(".add_to_cart");
        this.buyItNow = this.querySelector(".buy_it_now");
    }

    connectedCallback() {
        this._add();
        this._buy();
    }

    _add() {
        if (!this.addToCart) return;

        this.addToCart.addEventListener("click", async () => {
            const variantId = this.addToCart.getAttribute("data-variant-id");
            const quantity = this.addToCart.getAttribute("data-quantity") || 1;

            if (!variantId) {
                console.error("No variant ID on button!");
                return;
            }

            try {
                const response = await fetch('/cart/add.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                    body: JSON.stringify({ id: variantId, quantity: Number(quantity) })
                });

                const data = await response.json();

                document.dispatchEvent(
                    new CustomEvent('cart:update', {
                    bubbles: true,
                    detail:{
                        data: {
                        itemCount: 1,
                        source: 'product-form-component'
                        }
                    }
                    })
                );

                // Open cart drawer
                document.querySelector("cart-drawer-component")?.open();

            } catch (error) {
                console.error("Add to cart failed:", error);
            }
        });
    }

    _buy() {
        if (!this.buyItNow) return;

        this.buyItNow.addEventListener("click", async () => {
            const variantId = this.buyItNow.getAttribute("data-variant-id");
            const quantity = this.buyItNow.getAttribute("data-quantity") || 1;

            if (!variantId) {
                console.error("No variant ID on button!");
                return;
            }

            try {
                // Add to cart first
                await fetch('/cart/add.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                    body: JSON.stringify({ id: variantId, quantity: Number(quantity) })
                });

                // Redirect to checkout
                window.location.href = "/checkout";

            } catch (error) {
                console.error("Buy it now failed:", error);
            }
        });
    }
}

if (!customElements.get('jb-card-buttons')) {
    customElements.define('jb-card-buttons', JBCardButtons);
}

class JbProductTabsWrapper extends HTMLElement {
    constructor() {
        super();
        this.btns = [...this.querySelectorAll('a')];
    }
    connectedCallback() {
        this.btns.forEach((btn) => {
            btn.addEventListener('click', (e) => {
                this.btns.forEach((btn) => {
                    btn.classList.remove('active');
                });
                btn.classList.add('active');
            });
        });
    }
}

if (!customElements.get('jb-product-tabs-wrapper')) {
    customElements.define('jb-product-tabs-wrapper', JbProductTabsWrapper);
}